import { IconGripVertical } from '@tabler/icons-react';

import { cn } from '@/utils/tailwind';

interface SixDotIconProps {
  position: string;
  ref?: React.Ref<HTMLElement>;
  color?: 'gray' | 'white';
}

const SixDotIcon = ({ position, ref, color = 'gray' }: SixDotIconProps) => (
  <div
    ref={ref as React.Ref<HTMLDivElement>}
    className={cn(
      // Prevent browser scroll from stealing the gesture before drag activates.
      'cursor-grab touch-none',
      position === 'top' ? 'self-start' : 'self-center',
    )}
    data-testid="Draggable"
  >
    <IconGripVertical
      className={cn(
        color === 'gray' ? 'text-grayscale-gray3!' : 'text-white',
        '-ml-1',
      )}
    />
  </div>
);

export default SixDotIcon;
